import cn from 'classnames';
import * as React from 'react';

import {
  aspectRatios,
  loadings,
  CroppedImage as Props,
} from './cropped-image.types';

const CroppedImage: React.FunctionComponent<Props> & {
  aspectRatios: typeof aspectRatios;
  loadings: typeof loadings;
} = ({
  alt,
  aspectRatio = aspectRatios.sixteenNine,
  className,
  loading = loadings.lazy,
  src,
  srcQuery = '',
  ...rest
}) => (
  <div className={cn('cropped-image', aspectRatio, className)}>
    <img
      className="cropped-image__element"
      alt={alt}
      loading={loading}
      src={`${src}${srcQuery}`}
      {...rest}
    />
  </div>
);

CroppedImage.aspectRatios = aspectRatios;
CroppedImage.loadings = loadings;

export default CroppedImage;
